import { Injectable } from '@angular/core';

import { UserDataGrpcWebContractService } from '@lyra/app/core/api/grpc/services/user-data.service';
import { SettingSelectService } from '@lyra/app/core/store/selectors';
import { DateHelper } from '@mark/common-lib/helpers';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, tap, withLatestFrom } from 'rxjs';

import { GET_GOALS_COMMAND } from '../actions/goals.actions';
import { CHANGE_ROUTE, SET_LOADER } from '../actions/questionnaire.actions';
import * as actions from '../actions/user.actions';
import { UserSelectService } from '../selectors';
import { QuestionnaireSelectService } from '../selectors/questionnaire.selector';
import { IQuestionnaireState } from '../states/questionnaire.state';

@Injectable()
export class UserEffects {
  redirectToInitSurvey$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.SET_MAIN_USER_DATA),
      filter((x) => !!x.init),
      map(() => GET_GOALS_COMMAND()),
    ),
  );

  setGender$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.SET_GENDER),
      withLatestFrom(this._questionnaireSelect.getType()),
      // short-quiz collects no name — skip straight to birthday; the full flow asks for the name next.
      map(([, type]) => CHANGE_ROUTE({ route: type === 'short-quiz' ? 'birthday' : 'name' })),
    ),
  );

  setName$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.SET_NAME),
      map(() => CHANGE_ROUTE({ route: 'birthday' })),
    ),
  );

  setBirthday$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.SET_DATE_OF_BIRTH),
      withLatestFrom(this._settingSelect.getReferrerGoals(), this._userSelect.getMainUserData()),
      switchMap(([, referrerGoals, { DateOfBirth, GenderType, Name }]) =>
        this._userDataGrpcWebContractService
          .updateInfo({
            DateOfBirth: DateOfBirth ? DateHelper.getADFormDate(new Date(DateOfBirth)) : undefined,
            Gender: (GenderType as number) ?? undefined,
            FirstName: Name ?? undefined,
          })
          .pipe(
            tap(() => {
              if (!referrerGoals) {
                this._store$.dispatch(CHANGE_ROUTE({ route: 'goals' }));
              } else {
                this._store$.dispatch(SET_LOADER({ value: true }));
              }
            }),
            map(() => GET_GOALS_COMMAND()),
          ),
      ),
    ),
  );

  constructor(
    private _store$: Store<IQuestionnaireState>,
    private _actions$: Actions,
    private _settingSelect: SettingSelectService,
    private _userSelect: UserSelectService,
    private _questionnaireSelect: QuestionnaireSelectService,
    private _userDataGrpcWebContractService: UserDataGrpcWebContractService,
  ) {}
}
